/**
 * Snackbar copy for the competition picks screen (specs/champions-league Story 16).
 *
 * The picks card is optimistic twice over — a tapped scoreline renders instantly and saves
 * 650ms later, a tapped x2 fills instantly and is confirmed after the round trip — and until
 * now the only thing that ever spoke was failure. These are the success half.
 *
 * Division of labour, so the same news is never reported twice: the floating snackbar reports
 * SUCCESS, because success has nowhere to live on the card; the inline `SEASON_PICKS_SAVE_ERROR`
 * badge reports FAILURE, because a failure belongs beside the fixture that failed and a floating
 * message cannot say which one that was (AC-16.2).
 */

import { WORLD_CUP_PICK_PERSISTENCE_COPY } from '../../worldcup/hooks/useWorldCupPickPersistence.constants';

export const COMPETITION_PICK_FEEDBACK_COPY = {
  /**
   * Imported rather than re-typed: a player moving between the World Cup and a tournament
   * should read the same two words for the same event (AC-16.1).
   */
  PICK_SAVED: WORLD_CUP_PICK_PERSISTENCE_COPY.PICK_SAVED_MESSAGE,
  /** Placing or moving the round's x2. */
  BOOST_PLACED: 'Double points activated',
  /**
   * Taking it off. Distinct from the placement copy on purpose: the toggle's two outcomes are
   * opposite, and "double points activated" is simply false when the user just cleared it
   * (AC-16.3).
   */
  BOOST_CLEARED: 'Double points removed',
} as const;
